import {
    KARIGAR_SALARY_REPORT_REQUEST,
    KARIGAR_SALARY_REPORT_SUCCESS,
    KARIGAR_SALARY_REPORT_FAILURE,
    KARIGAR_SALARY_FILTER_REPORT_REQUEST,
    KARIGAR_SALARY_FILTER_REPORT_SUCCESS,
    KARIGAR_SALARY_FILTER_REPORT_FAILURE,
  } from "../types/karigar-salary-report-types";
  
  const initialState = {
    karigarSalaryReport: {},
    karigarSalaryFilterReport: {},
    loading: false,
    error: null,
  };

  const karigarSalaryReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case KARIGAR_SALARY_REPORT_REQUEST, KARIGAR_SALARY_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case KARIGAR_SALARY_REPORT_SUCCESS: {
        return {
          ...state,
          karigarSalaryReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case KARIGAR_SALARY_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          karigarSalaryFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case KARIGAR_SALARY_REPORT_FAILURE, KARIGAR_SALARY_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };

  export default karigarSalaryReportReducer;
  